/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/glbalance.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./glbalance_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.GLBalanceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.GLBalanceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListGLBalanceRequest,
 *   !proto.reportpb.ListGLBalanceResponse>}
 */
const methodDescriptor_GLBalanceService_ListGLBalance = new grpc.web.MethodDescriptor(
  '/reportpb.GLBalanceService/ListGLBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListGLBalanceRequest,
  proto.reportpb.ListGLBalanceResponse,
  /**
   * @param {!proto.reportpb.ListGLBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListGLBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListGLBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListGLBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListGLBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.GLBalanceServiceClient.prototype.listGLBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.GLBalanceService/ListGLBalance',
      request,
      metadata || {},
      methodDescriptor_GLBalanceService_ListGLBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListGLBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListGLBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.GLBalanceServicePromiseClient.prototype.listGLBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.GLBalanceService/ListGLBalance',
      request,
      metadata || {},
      methodDescriptor_GLBalanceService_ListGLBalance);
};


module.exports = proto.reportpb;

